<template lang="pug">
div
  .result-list__elements(v-if="!hasInput" :class="minHeightClass()")
    ul(v-for="(element, key) in parentsFilteredByLetter", :key="element.id")
      div(v-if="hasChildren(element)")
        div(
          data-toggle="collapse",
          :href="'#' + key",
          :id="key + '_parent'",
          role="button",
          aria-expanded="false",
          :aria-controls="key",
          :class="'result-list__items ' + parentClass(key)"
        ) {{ key }}
          i.fas.fa-angle-down
        .collapse.multi-collapse(:id="key", :class="{ show: parentClass(key) }")
          navigation-list-element-vue(
            v-for="childrenId in element",
            :key="childrenId"
            :elementId="childrenId",
            :elementName="facetNames[childrenId]",
            :selected="activeElement(childrenId)",
            @perform:search="search"
          )
      navigation-list-element-vue(
        v-else,
        :elementId="element[0]",
        :elementName="facetNames[element[0]]",
        :selected="activeElement(element[0])",
        @perform:search="search"
      )
</template>

<script>
import mixins from "common/mixins.js";
import { mapMutations, mapActions, mapState } from "vuex";
import { domainBreadcrumb } from "common/classes/breadcrumbs.js";

export default {
  name: "navigation-list-elements-vue",
  mixins: [mixins.filters, mixins.translate, mixins.regex_utils],
  data() {
    return {
      currentSearch: { id: '', name: '' },
    };
  },
  props: {
    preselectedFilters: { type: Array, default: () => [] },
    filteredListElements: { type: Array, default: () => [] },
    filterName: { type: String, default: "" },
    inputSearchGroups: { type: Array, default: () => [] },
    facetNames: { type: Object, default: () => {} },
    hasInput: { type: Boolean, default: () => false },
    currentElements: { type: Object, default: () => { return {} } },
    currentLetter: { type: String, default: "" },
    currentOption: { type: String, default: "" },
    optionFilterName: { type: String, default: '' }
  },
  components: {
    "navigation-list-element-vue": () =>
      import(
        /* webpackChunkName: "[request]" */ "components/forms/NavigationListElement.vue"
      ),
  },
  computed: {
    parentsFilteredByLetter() {
      if (this.currentLetter == "") {
        return this.currentElements;
      } else {
        return Object.fromEntries(
          Object.entries(this.currentElements).filter(
            ([key]) => this.currentLetter.toLowerCase() == this.text_to_normalized(key[0])
          )
        );
      }
    },
    hasFilteredListElements() {
      return this.filteredListElements.length > 0;
    },
    relatedPreselectedFilter() {
      return this.preselectedFilters.find(
        (element) => element.name == this.filterName
      );
    },
    hasFilterOptionApplied(){
      return this.currentOption !== '' && this.optionFilterName !== ''
    },
    ...mapState("search", ['filters','savedOption']),
  },
  methods: {
    parentClass(parentId) {
      let parentSelected = this.currentSearch.id.split("-")[0];
      if (parentId)
        return parentId.toLowerCase() == parentSelected ? "active" : "";
    },
    minHeightClass() {
      return gon.current_app != "tol" ? "result-list__elements-filters" : "";
    },
    activeElement(id) {
      if (this.currentSearch.id == id) {
        return true;
      }
      return false;
    },
    search(element) {
      this.currentSearch = element;
      this.setSearchParameters(element.id);
      this.saveBreadcrumbs();
      this.performSearch();
    },
    setSearchParameters(id) {
      let navigationListFilters = [this.new_filter(this.filterName, [id])]
      if(this.hasFilterOptionApplied)
        navigationListFilters.push(this.new_filter(this.optionFilterName, [this.currentOption]))
      this.setFilters(navigationListFilters);
      this.setSearchGroups(this.inputSearchGroups);
      this.setSearchType("general");
    },
    hasChildren(element) {
      return element.length > 1;
    },
    saveBreadcrumbs() {
      let service = new domainBreadcrumb(
        this.currentSearch, gon.current_app, this.currentElements, this.savedOption
      )
      this.setBreadcrumbs(service.getBreadcrumbs())
    },
    ...mapMutations("search", [
      "setFilters",
      "setSearchType",
      "setSearchGroups",
      "setBreadcrumbs",
    ]),
    ...mapActions("search", ["performSearch"]),
  },
  watch:{
    filters(value){
      let empty_filters = value.length == 0
      if(empty_filters){
        this.currentSearch = { id: '', name: '' }
      }
    }
  },
  mounted() {
    if (this.relatedPreselectedFilter) {
      this.search(this.relatedPreselectedFilter.values[0]);
    }
  },
};
</script>
